module.exports = __webpack_public_path__ + "img/chest.33edfcaf.jpeg";